<template>
  <div :class="[(checked) ? 'list-group-item-primary' : '', 'list-group-item']">
    <div class="d-flex w-100 justify-content-between">
      <span>{{ hour }} - {{ end }}</span>
      <div v-if="editable" class="has-text-centered icons">
        <input class="form-check-input me-1" type="checkbox" 
          value="1"
          ref="hourSelected"
          @click="selectHour(hour, end)"
          aria-label="Book now!"> 
        Book now!
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/*function getTwentyFourHourTime(amPmString) { 
	var d = new Date("1/1/2024 " + amPmString); 
	return d.getHours() + ':' + d.getMinutes(); 
}*/
	
export default {
  name: 'CalendarHour',
  props: ['id', 'room', 'day', 'hour', 'end', 'index', 'editable'],
  computed: {
    ...mapGetters([
      'user',
      'getSelectedHours',
      'offlineMode'
    ]),
  },
  data() {
    return {
      checked: false
    };
  },
  methods: {
    selectHour(startHour, endHour) {
      let newSelectedHour;
			/*let startHour = getTwentyFourHourTime(startHourInt)
			let endHour = getTwentyFourHourTime(endHourInt)
			console.log('startHourInt = '+ startHourInt +', endHourInt = '+ endHourInt)
			console.log('startHour = '+ startHour +', endHour = '+ endHour)*/
      if (this.getSelectedHours > 0) {
        newSelectedHour = {'index': this.index, 'startHour': startHour, 'endHour': endHour};
      } else {
        newSelectedHour = { 'fairId': Number(this.id), 'roomId': this.room.id, 'dayId': this.day.id, 'room': this.room.title, 'day': this.day.title, 'items': [{'index': this.index, 'startHour': startHour, 'endHour': endHour}]};
      }
      if (this.$refs.hourSelected.checked == true) {
        this.checked = true;
        this.$store.dispatch('selectHour', newSelectedHour).then(() => {
          this.$store.dispatch('setRequestDetail')
        })
      } else {
        this.checked = false;
        this.$store.dispatch('removeHour', newSelectedHour).then(() => {
          this.$store.dispatch('setRequestDetail')
        })
      }
    },
  },
}
</script>

<style scoped>
</style>
